import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import {
  FluentProvider,
  webLightTheme,
  PartialTheme,
  Theme
} from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

const brandColor = "#921784";
const brandColorHover = "#7a136e";
const brandColorActive = "#600f56";

const lexfaniaCustomTheme: PartialTheme = {
  colorBrandBackground: brandColor,
  colorBrandBackgroundHover: brandColorHover,
  colorBrandBackgroundPressed: brandColorActive,
  colorNeutralForegroundOnBrand: "#ffffff",
};

const mergedTheme: Theme = {
   ...webLightTheme,
   ...lexfaniaCustomTheme,
};



const title = "Lexfania Task Pane Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  if (root) {
    root.render(
      <FluentProvider theme={mergedTheme}>
        <App title={title} />
      </FluentProvider>
    );
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    if (root) {
      root.render(
        <FluentProvider theme={mergedTheme}>
           <NextApp title={title} />
        </FluentProvider>
      );
    }
  });
}
